// src/app/guards/user-agent.guard.ts
import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ROUTE_CONSTANTS } from 'app/util/route.constants';
import { of } from 'rxjs';

export const userAgentGuard: CanActivateFn = () => {
  const router = inject(Router);
  const urlTree = router.parseUrl(`${ROUTE_CONSTANTS.INVALID_AGENT}`);
  const ALLOWED_USER_AGENT_PART = 'AeroCloud/';

  const currentUserAgent = window.navigator.userAgent;

  if (currentUserAgent) {
    const isUserAgentAllowed = currentUserAgent.toLowerCase().includes(ALLOWED_USER_AGENT_PART.toLowerCase());

    if (isUserAgentAllowed) {
      console.log(`User Agent Allowed: ${currentUserAgent}`);
      return true; // Allow navigation
    } else {
      console.warn(`Access Denied: User Agent "${currentUserAgent}" does not match allowed pattern.`);
      return of(urlTree); // Redirect to the error page
    }
  }

  // If user-agent couldn't be determined (e.g., in an unexpected platform, or SSR setup issue)
  console.error('User Agent could not be determined. Denying access for safety.');
  return of(urlTree);
};